import React, {Component} from 'react';
import {Button, Skeleton} from "antd";
import {getLeasingStatus} from "../../appRedux/actions";
import {connect} from "react-redux";
import './style.css';

const label = {
    'OPEN': 'Available',
    'CLOSED': 'Under Lease',
    'BLOCKED': 'Blocked',
    'EXPIRED': 'Expired',
    '': '-',
    'NaN': '',
    undefined: '',
    null: ''
}

class Vendor extends Component {
    constructor(props) {
        super(props);
        this.statusArray = {'': 'dashed', 'EXPIRED': 'danger', 'CLOSED': 'error', 'OPEN': 'primary'};
        this.state = {
            status: {},
            load: {},
            contract: {},
            cachedStatus: null
            // color: 'primary',

        }
    }

    componentDidMount() {
        // if (this.props.id) {
        //     const allStatus = this.props.allStatus;
        //     if (!allStatus[this.props.id])
        //         this.props.getLeasingStatus(this.props.id);
        //     else {
        //         console.log(this.props.id, allStatus[this.props.id] && allStatus[this.props.id][this.props.id])
        //         this.setState({
        //             cachedStatus: allStatus[this.props.id]
        //         })
        //     }
        // }
    }

    //
    // shouldComponentUpdate(nextProps, nextState, nextContext) {
    //     // console.log('here', nextProps.status)
    //     return true;
    // }

    componentWillReceiveProps(nextProps, nextContext) {
        console.log(nextProps.allStatus)
        if (nextProps.allStatus /*&& JSON.stringify(nextProps.allStatus) !== JSON.stringify(this.props.allStatus)*/) {
            this.setState({
                cachedStatus: nextProps.allStatus[this.props.id]
            })
        }
    }

    componentDidUpdate(prevProps, prevState) {
        // if (!this.state.cachedStatus && prevProps.status !== this.props.status) {
        // // console.log('3. ', prevProps, this.props);
        // let st = this.state.status;
        // let ld = this.state.load;
        // let con = this.state.contract;
        // if (this.props.status !== null && this.props.status.status !== null) {
        //     st[this.props.status.id] = this.props.status.status.status;
        //     ld[this.props.status.id] = this.props.status.loading;
        //     con[this.props.status.id] = this.props.status.status.contract;
        //     this.setState({
        //         status: st,
        //         load: ld,
        //         contract: con,
        //     })
        //     this.props.addStatusToRecord(this.props.id, {
        //         status: st,
        //         load: ld,
        //         contract: con,
        //     })
        // }
        // }
    }

    onClick = (contract) => {
        if (contract) {
            const {match, history} = this.props;
            history.push(`contract/view/${contract._id}`);
        }
    };

    btnText = (contract, label) => {
        if (contract && contract.id) {
            return contract.id;
        } else return label || 'NA'
    };

    render() {
        const {status, load, contract, cachedStatus} = this.state;
        console.log(this.props.id, cachedStatus && cachedStatus['contract'] && cachedStatus['contract'][this.props.id] && cachedStatus['contract'][this.props.id].vendor && cachedStatus['contract'][this.props.id].vendor.name)
        const name = cachedStatus && cachedStatus['contract'] && cachedStatus['contract'][this.props.id] && cachedStatus['contract'][this.props.id].vendor && cachedStatus['contract'][this.props.id].vendor.name || 'NA'
        return (
            <div style={{width: '50%'}}>{name}
            </div>
        );
    }
}


const mapStateToProps = ({auth, leasing}) => {
    return {
        authUser: auth.authUser,
        loading: leasing.leasingStatusLoading,
        status: leasing.leasingStatus,
    }
};

function mapDispatchToProps(dispatch) {
    return {
        getLeasingStatus
    };
}

export default connect(mapStateToProps, mapDispatchToProps())(Vendor);
